import { i18nReporting } from 'models/i18n';
import {
  AggregationFn,
  BenefitCostType,
  BenefitEvaluation,
  EconomicBenefitReportFields
} from 'views/modules/Reporting/EconomicBenefitReports/economicBenefitUtils';

const reporting: i18nReporting = {
  economicBenefit: {
    aggregation: {
      [AggregationFn.MEAN]: 'Denný priemer',
      [AggregationFn.CUMULATIVE_SUM]: 'Kumulovaná suma'
    },
    aggregationLabel: 'Agregácia',
    aggregationFrom: 'Dátum od',
    aggregationTo: 'Dátum do',
    evaluationDate: 'Dátum',
    evaluation: {
      [BenefitEvaluation.ECONOMIC_BENEFIT_EVALUATION_DAY]: 'Denné',
      [BenefitEvaluation.ECONOMIC_BENEFIT_EVALUATION_MONTH]: 'Mesačné'
    },
    exportToCsv: {
      dialogTitle: 'Export reportu do CSV',
      evaluationSelectLabel: 'Granularita reportu',
      openExportModalButton: 'Export CSV',
      reportType: {
        [BenefitEvaluation.ECONOMIC_BENEFIT_EVALUATION_PERIOD]: 'Periodický',
        [BenefitEvaluation.ECONOMIC_BENEFIT_EVALUATION_HOUR]: 'Hodinový',
        [BenefitEvaluation.ECONOMIC_BENEFIT_EVALUATION_DAY]: 'Denný'
      },
      columns: {
        [EconomicBenefitReportFields.BALANCING_GROUP_ID]: 'Bilančná skupina',
        [EconomicBenefitReportFields.MONTH]: 'Mesiac',
        [EconomicBenefitReportFields.MARKET_DAY]: 'Obchodný deň',
        [EconomicBenefitReportFields.MARKET_PERIOD_START]: 'Začiatok periódy',
        [EconomicBenefitReportFields.MARKET_PERIOD_END]: 'Koniec periódy',
        [EconomicBenefitReportFields.POSITIVE_IMBALANCE_MWH]:
          'Pozitívna odchýlka [MWH]',
        [EconomicBenefitReportFields.NEGATIVE_IMBALANCE_MWH]:
          'Negatívna odchýlka [MWH]',
        [EconomicBenefitReportFields.TOTAL_IMBALANCE_PRICE_EUR]:
          'Celková cena odchýlky [Eur]',
        [EconomicBenefitReportFields.IMBALANCE_UNIT_PRICE_EUR]:
          'Jednotková cena odchýlky [Eur/MWh]',
        [EconomicBenefitReportFields.POSITIVE_IMBALANCE_MODEL_MWH]:
          'Pozitívna odchýlka modelu [MWh]',
        [EconomicBenefitReportFields.NEGATIVE_IMBALANCE_MODEL_MWH]:
          'Negatívna odchýlka modelu [MWh]',
        [EconomicBenefitReportFields.TOTAL_IMBALANCE_MODEL_PRICE_EUR]:
          'Celková cena odchýlky modelu [Eur]',
        [EconomicBenefitReportFields.IMBALANCE_MODEL_UNIT_PRICE_EUR]:
          'Jednotková cena odchýlky modelu [Eur/MWh]',
        [EconomicBenefitReportFields.IMBALANCE_PRICE_DIFFERENCE_EUR]:
          'Rozdiel ceny odchýlky [Eur]',
        [EconomicBenefitReportFields.IMBALANCE_UNIT_PRICE_DIFFERENCE_EUR]:
          'Rozdiel jednotkovej ceny odchýlky [Eur/MWh]',
        [EconomicBenefitReportFields.RESERVED_CAPACITY_EXCEEDING_PRICE_EUR]:
          'Cena prekročenia RK [Eur]',
        [EconomicBenefitReportFields.RESERVED_CAPACITY_EXCEEDING_COUNT]:
          'Počet prekročení RK',
        [EconomicBenefitReportFields.RESERVED_CAPACITY_EXCEEDING_MWH]:
          'Prekročenie RK [MWh]',
        [EconomicBenefitReportFields.RESERVED_CAPACITY_EXCEEDING_DETECTED_PRICE_EUR]:
          'Cena prekročenia RK detekovaná [Eur]',
        [EconomicBenefitReportFields.RESERVED_CAPACITY_EXCEEDING_DETECTED_COUNT]:
          'Počet prekročení RK detekovaných',
        [EconomicBenefitReportFields.RESERVED_CAPACITY_EXCEEDING_DETECTED_MWH]:
          'Prekročenie RK detekované [MWh]',
        [EconomicBenefitReportFields.RESERVED_CAPACITY_EXCEEDING_PRICE_DIFFERENCE_EUR]:
          'Rozdiel ceny prekročenia RK [Eur]',
        [EconomicBenefitReportFields.RESERVED_CAPACITY_EXCEEDING_DETECTED_PRICE_EUR]:
          'Rozdiel ceny prekročenia RK detekovaná [Eur]',
        [EconomicBenefitReportFields.MARKET_HOUR_START]: 'Začiatok hodiny',
        [EconomicBenefitReportFields.MARKET_HOUR_END]: 'Koniec hodiny'
      }
    },
    tableColumns: {
      realBenefit: 'Skutočný prínos',
      difference: 'Rozdiel',
      withAORTA: 'S AORTA',
      withoutAORTA: 'Bez AORTA'
    },
    tableRows: {
      deviation: 'Odchýlka',
      unitCostOfDeviation: 'Jedn. náklady na odchýlku',
      deviationSize: 'Veľkosť odchýlky',
      costOfExceedingReservedCapacity: 'Náklady na prekročenie RK'
    },
    tableTooltip: {
      energy: 'Energia',
      exceedingCount: 'Počet prekročení'
    },
    charts: {
      benefitChartsTitle: 'Výnosy na odchýlke',
      cumulativeBenefitsChartTitle: 'Kumulatívne výnosy na odchýlke',
      cost: {
        [BenefitCostType.SUMMARY]: 'Sumárne',
        [BenefitCostType.UNIT]: 'Jednotkové'
      },
      labels: { period: 'Perióda', day: 'Deň' },
      series: {
        [EconomicBenefitReportFields.TOTAL_IMBALANCE_PRICE_EUR]: 's AORTA',
        [EconomicBenefitReportFields.TOTAL_IMBALANCE_MODEL_PRICE_EUR]:
          'bez AORTA'
      }
    }
  },
  tableColumns: {
    date: 'Obchodný deň',
    period: 'Zúčtovacia perióda',
    period_start: 'Začiatok periódy',
    period_end: 'Koniec periódy',
    system_imbalance_mwh: 'Veľkosť odchýlky [MWh]',
    system_imbalance_eur_mwh: 'Cena odchýlky [Eur/MWh]',
    predicted_value_d1: 'Predikcia odchýlky D+1 [MWh]',
    predicted_value_hx: 'Predikcia odchýlky H+X [MWh]',
    prediction_success_d1: 'Úspešnosť predikcie D+1 [MWh]',
    prediction_success_hx: 'Úspešnosť predikcie H+X [MWh]',
    ems_party_id: 'ID subjektu',
    ems_party_name: 'Názov subjektu',
    balancing_group_id: 'ID bilančnej skupiny',
    balancing_group_name: 'Názov bilančnej skupiny',
    delivery_point_id: 'ID odberného miesta',
    delivery_point_name: 'Názov odberného miesta',
    device_id: 'ID zariadenia',
    device_name: 'Názov zariadenia',
    load_nomination: 'Nominovaná spotreba [MWh]',
    load_plan: 'Plánovaná spotreba [MWh]',
    load_real: 'Skutočnosť spotreby [MWh]',
    load_imbalance: 'Odchýlka spotreby bilančnej skupiny [MWh]',
    generation_nomination: 'Nominovaná výroba [MWh]',
    generation_plan: 'Plánovaná výroba [MWh]',
    generation_real: 'Skutočnosť výroby [MWh]'
  },
  dateFrom: 'Dátum od',
  dateTo: 'Dátum do'
};

export default reporting;
